// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__PhxfM","col":"styles_col__22sjn","fulfillmentStatus":"styles_fulfillmentStatus__1ADsS","emailCol":"styles_emailCol__NGUKl"};